import ContactHelpers from '../helpers/ContactHelpers'
import DataHelpers from '../helpers/DataHelpers'

import Vue from 'vue'

//seperated from taghelpers because this one had dates and lowercase tags.

export default class {

    static cleanTagName(tagName) {
        if(!tagName)
            return ''
        const newTagName = tagName.toLowerCase().replace(' ', '_').trim()
        return newTagName
    }
    static addTag(tagObj, name, date=new Date()) {
        const tagName = this.cleanTagName(name)
        const dateLabel = tagName + '-date'
        const userLabel = tagName + '-user'
        const userName = ContactHelpers.fullName(DataHelpers.getUser())
        Vue.set(tagObj, tagName, true)
        Vue.set(tagObj, dateLabel, date)
        Vue.set(tagObj, userLabel, userName)
    }

    static tagExists(tagObj, name) {
        const tagName = this.cleanTagName(name)
        if(!tagObj)
            return false
        return !!tagObj[tagName]
    }

    static tagDate(tagObj, name) {
        const tagName = this.cleanTagName(name) + '-date'

        if(!tagObj)
            return null
        return tagObj[tagName] || null
    }

    static tagUser(tagObj, name) {
        const tagName = this.cleanTagName(name) + '-user'

        if(!tagObj)
            return null
        return tagObj[tagName] || null
    }

    //Arrays

    static itemsWithTag(arr, tagName) {
        return arr.filter(o => o.tags && o.tags[tagName])
    }

    static itemsWithoutTag(arr, tagName) {
        return arr.filter(o => !o.tags || !o.tags[tagName])
    }
}


// WEBPACK FOOTER //
// ./src/helpers/TagStatusHelpers.js